// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602161156/js/" + chunkId + "." + {"44":"0f2e5f3b","225":"a7d1e0cd","481":"79750e94","486":"ebb69b4f","770":"52cba0c0"}[chunkId] + ".0.14400266917728244.chunk.js";
};